// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3lyJS","title":"Header_title__Gz8SD","left":"Header_left__1ugQ6","clinicName":"Header_clinicName__2gTEi"};